import TopHeadScreen from "../../component/layout/tophead";
import SidebarScreen from "../../component/layout/sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import AgentSidebarScreen from "../../component/layout/agent-sidebar";
import AgentTopHeadScreen from "../../component/layout/agent-header";
import EmployerHeaderScreen from "../../component/layout/employerheader";
import EmployerSidebarScreen from "../../component/layout/employer-sidebar";
import NotificationScreen from "./common/notification";

const Notification = () => {
  const { user } = useSelector((state: RootState) => state.authSlice);
  const { notifications } = useSelector(
    (state: RootState) => state.notificationSlice
  );

  return (
    <>
      <div className="main">
        <section className="profileJobDetails-area">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 sidebar  position-relative p-0">
                {/* <SidebarScreen /> */}
                {user && user?.role === "jobseeker" && <SidebarScreen />}
                {user && user?.role === "localagents" && <AgentSidebarScreen />}
                {user && user?.role === "employer" && <EmployerSidebarScreen />}
              </div>
              <div className="col-lg-10 rightcontent p-0">
                {user && user?.role === "jobseeker" && <TopHeadScreen />}
                {user && user?.role === "localagents" && <AgentTopHeadScreen />}
                {user && user?.role === "employer" && <EmployerHeaderScreen />}
                {/* <TopHeadScreen /> */}
                <div className="profileJoblisting-holder rightInnerScroll">
                  <div className="row">
                    <div className="col-lg-12  pt-3 mb-4">
                      {/* filterHolder */}
                      <div className="filterResults">
                        <div className="title">
                          <h2>Notification</h2>
                        </div>
                        <NotificationScreen
                          notifications={notifications}
                          asPage={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />
    </>
  );
};
export default Notification;
